/* eslint-disable import/no-anonymous-default-export */
export default (claims, token, { name, id, department, jobTitle, userId }) => ({
  username: claims.given_name,
  arn: claims.sub,
  fullname: `${claims.given_name} ${claims.family_name}`,
  email: claims.email,
  picture: claims.picture
    ? import.meta.env.VITE_IMAGE_BUCKET + 'users/' + claims.picture
    : null,
  isSuperAdmin: claims['custom:platform_super_admin'] === 'true',
  jobTitle,
  department,
  token: token,
  entityName: name,
  entityId: id,
  userId,
});
